import Vue from 'vue';
export const RegisterEventBus = new Vue();
